import { render, staticRenderFns } from "./createAlert.vue?vue&type=template&id=4b64950c&"
import script from "./createAlert.vue?vue&type=script&lang=js&"
export * from "./createAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports